// extracted by mini-css-extract-plugin
module.exports = {"form":"form__yLOKp","col":"col__DN-c2","inputWrap":"inputWrap__PBOS2","accountantUserEmailError":"accountantUserEmailError__SXrpy"};